/**
 * Ends a `switch` over a union so that adding a member without handling it fails to compile, and fails loudly at
 * runtime rather than falling through into a default behaviour.
 */
export const assertUnreachable = (unhandled: never): never => {
    throw new Error(`Unhandled case: ${JSON.stringify(unhandled)}`)
}
